import Chart from 'chart.js/auto';
import def_day_lines, { xAxisConfig, tooltipCallbacks, enableTouchPan } from './graph_utils.js';

export default function graph_pcpn(ser, times, ff, var_S){

  var neige   = new Array(ff.length);
  var pluie   = new Array(ff.length);
  var verglas = new Array(ff.length);
  var pr      = new Array(ff.length);
  var pe      = new Array(ff.length);

  const xy = (arr) => times.map((t, i) => ({ x: t.getTime(), y: arr[i] }));

  if(var_S == "ALL" || var_S == "PE"){
    for(let i=0; i < ff.length; i++){
      neige[i]   = ff[i][0];
      pluie[i]   = ff[i][1];
      verglas[i] = ff[i][2];
      pr[i]      = ff[i][3];
      pe[i]      = pr[i] - (neige[i] + pluie[i] + verglas[i]);
    }
  } else if(var_S == "SN"){
    for(let i=0; i < ff.length; i++) neige[i]   = ff[i][0];
  } else if(var_S == "RN"){
    for(let i=0; i < ff.length; i++) pluie[i]   = ff[i][0];
  } else if(var_S == "FR"){
    for(let i=0; i < ff.length; i++) verglas[i] = ff[i][0];
  } else if(var_S == "PR"){
    for(let i=0; i < ff.length; i++) pr[i]      = ff[i][0];
  }

  var sn_color = 'rgb(52 , 116 , 235)';
  var rn_color = 'rgb(40 , 200 , 40 )';
  var fr_color = 'rgb(200, 50  , 50  )';
  var pe_color = 'rgb(235, 52  , 201)';
  var pr_color = 'rgb(0  , 0   , 0)';

  var datasets;
  if(var_S == "ALL"){
    datasets = [
      { label: 'Neige',   data: xy(neige),   borderColor: sn_color, lineTension: 0.2 },
      { label: 'Pluie',   data: xy(pluie),   borderColor: rn_color },
      { label: 'Verglas', data: xy(verglas),  borderColor: fr_color, lineTension: 0.2 },
      { label: 'Grésil',  data: xy(pe),       borderColor: pe_color, lineTension: 0.2 },
      { label: 'Total',   data: xy(pr),       borderColor: pr_color, lineTension: 0.2 },
    ];
  } else if(var_S == "SN"){
    datasets = [{ label: 'Neige',   data: xy(neige),   borderColor: sn_color, lineTension: 0.2 }];
  } else if(var_S == "RN"){
    datasets = [{ label: 'Pluie',   data: xy(pluie),   borderColor: rn_color }];
  } else if(var_S == "FR"){
    datasets = [{ label: 'Verglas', data: xy(verglas),  borderColor: fr_color, lineTension: 0.2 }];
  } else if(var_S == "PE"){
    datasets = [{ label: 'Grésil',  data: xy(pe),       borderColor: pe_color, lineTension: 0.2 }];
  } else if(var_S == "PR"){
    datasets = [{ label: 'Total',   data: xy(pr),       borderColor: pr_color, lineTension: 0.2 }];
  }

  var ann = [];
  def_day_lines(times, ann);

  const ctx = document.getElementById('id_series_canvas');
  if(ser.chart){
    ser.chart.destroy();
  }
  ser.chart = new Chart(ctx, {
    type: 'line',
    data: { datasets },
    options: {
      maintainAspectRatio: false,
      animations: false,
      responsive: true,
      scales: {
        x: xAxisConfig(times),
        y: {
          title: {
            display: true,
            text: 'Accumulation équivalent eau [mm]'
          },
          min: 0,
        }
      },
      plugins: {
        tooltip: { callbacks: tooltipCallbacks },
        annotation: {
          adjustScaleRange: false,
          annotations: ann
        },
        zoom: {
          zoom: {
            wheel: { enabled: true },
            pinch: { enabled: true },
            mode: "x",
            speed: 100
          },
          pan: {
            enabled: true,
            mode: "x",
            speed: 100
          }
        }
      }
    }
  });
  enableTouchPan(ser.chart);
}
